module.exports = __webpack_public_path__ + "img/step2.71d85d84.png";